import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { CommentActionReopen } from "@components/QaReview/components/CommentActionReopen";
import { CommentActionReplies } from "@components/QaReview/components/CommentActionReplies";
import { CommentActionReply } from "@components/QaReview/components/CommentActionReply";

interface CommentActionsProps {
  comment: ReviewItemFieldsFragment;
  /** Goes to the comment's field; the replies toggle calls it, as clicking the card does. */
  onActivate?: () => void;
}

export const CommentActions: React.FC<CommentActionsProps> = ({ comment, onActivate }) => (
  <div className="flex w-full flex-wrap items-center justify-between gap-0.5">
    <CommentActionReplies comment={comment} onActivate={onActivate} />

    <div className="ml-auto flex flex-wrap items-center justify-end gap-0.5">
      <CommentActionReopen comment={comment} />
      <CommentActionReply comment={comment} />
    </div>
  </div>
);
